<template>
  <div
      class="image-modal-wrapper position-fixed align-items-center justify-content-center d-flex position-fixed">
    <div class="modal-inner  align-items-center justify-content-center d-flex">
      <div class="bm-image-modal-content  bg-white px-24 pt-24  pb-26 position-fixed rounded rounded-4 scroller w-100 h-100">
        <div
            class="p-0 border-0 text-end close-icon-wrapper custom-icon"
            @click="handleModalClose">
          <icon name="close-icon"/>
        </div>
        <div class="bm-modal-body border-0 mt-3">
          <h2 class="text-center modal-heading text-dark-gray fs-24  mb-0">Removed Background Images</h2>
          <div class="tabs-wrapper">
            <div class="main-tabs-content mt-20">
              <div>

              </div>
            </div>

          </div>
        </div>
        <div class="bg-images-wrapper">
          <div v-for="(image, i) in getBgRemoverImages" :key="i"
               class="image-wrapper" @click.stop="selectedImage(image, i)">
            <img
                ref="galleryVariable"
                :src="image"
                :id="i"
            >
          </div>
        </div>
      </div>
    </div>
    <div
        class="backdrop position-fixed h-100 w-100"
        @click="handleModalClose"/>
  </div>
</template>

<script>
import EventBus from '@/EventBus';
import axios from "axios";
export default {
  name: "BgRemoverModal",
  props: {
    activeObject: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getBgRemoverImages() {
      return this.$store.getters.getBgRemoverImagesList.thumbnail;
    }
  },
  methods: {
    selectedImage(image, index) {
      EventBus.$emit('showHideLoader', true);
      const response  = this.$store.getters.getBgRemoverImagesList;
      const imageURL = `https://processor.gangifyapp.com/downloads/${response.converted[index]}`;
      fetch(imageURL)
          .then(async (res) => {
            if (!res.ok) {
              throw new Error("Failed to fetch the image.");
            }
            const name = this.activeObject.AlternativeImageUrlsResVersion.Name ? this.activeObject.AlternativeImageUrlsResVersion.Name : this.activeObject.Name
            const blob = await res.blob();
            const file = new File([blob], `${name}_bg.png`, { type: blob.type });
            this.getBase64(file);
          });
      this.handleModalClose();
    },
    handleModalClose() {
      this.$store.commit('updateIsBgRemoverOpen', false);
    },

    getBase64(file, fileType) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{00000000-0000-0000-0000-000000000000}';

      const regextext = /[/\\?%*:|"<>@!~`()• ]/g;
      regextext.test(file.name) && (file =  new File([file.slice(0, file.size, file.type)], file.name.replaceAll(regextext, '-'), { type: file.type }));
      const imageData                 = {
        Id:                   '',
        Name:                 file.name,
        DefaultImageUrl:      '',
        ImageType:            'Image',
        CropOption:           'NotSpecified',
        ImageThumbnailPath:   '',
        ImageThumbnailPathV2: '',
      };
      const imageExtension            = imageData.Name.substring(imageData.Name.lastIndexOf('.') + 1, imageData.Name.length);
      const imageNameWithOutExtension = imageData.Name.substring(0, imageData.Name.lastIndexOf('.'));
      const reqFormData               = new FormData();
      reqFormData.append('file', file);
      const headers = {
        'Content-Type': 'text/plain',
      };

      const serverURL = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      axios.post(`https://${serverURL}.com/webservices/UploadImages.ashx?userId=21d29854-fb88-45e6-9a12-b1f4e6c67d45`, reqFormData, { headers })
          .then(async (res) => {
            const url                         = res.data;
            imageData.Id                      = url.substring(url.lastIndexOf('#') + 1, url.length);
            const returnedName                = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('#'));
            imageData.ImageThumbnailPath      = imageExtension === 'svg' ? url : `https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-${
                returnedName}`;
            imageData.ImageThumbnailPathV2    = imageData.ImageThumbnailPath;
            imageData.DefaultImageUrl         = url.substring(0, url.lastIndexOf('#'));
            EventBus.$emit('addBgRemoverImage', imageData);
            EventBus.$emit('AddImageNewImageToMyGalleryImages', imageData);
            EventBus.$emit('showHideLoader', false);
          })
          .catch((e) => {
            EventBus.$emit('showHideLoader', false);
            throw new Error(e.message);
          });
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
  }
}
</script>

<style lang="scss">
.image-modal-wrapper {
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 4000;
  .bm-image-modal-content {
    min-width: 600px;
    height: calc(100vh - 40px) !important;
    //height: fit-content !important;
    width: 70vw !important;
    box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    z-index: 99;
  }
  .bm-modal-content {
    min-width: 600px;
    height: fit-content !important;
    width: 70vw !important;
    box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    z-index: 99;
  }


  .modal-heading {
    font-weight: 600;
    line-height: 32px;
  }


  .backdrop {
    background-color: rgba(237, 237, 237, 0.6);
    filter: blur(4px);
    top: 0;
    left: 0;
    z-index: 0;
  }

  .close-icon {
    right: 10px;
    top: 10px;
  }
}

.close-icon-wrapper {
  .icon {
    display: inline-flex !important;
    cursor: pointer;
  }
}
.bg-images-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
  align-items: center;
  max-height: 590px;
  overflow: hidden;
  padding: 10px;

  .image-wrapper {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 270px;
    width: 490px;
    overflow: hidden;
    border-radius: 8px;

    img {
      height: 100%;
      width: auto;
      object-fit: contain;
    }

    &:hover {
      box-shadow: 0 0 8px 4px rgba(0,0,0,0.2);
    }
  }
}

</style>